const KeyboardShortcuts = () => null;
export default KeyboardShortcuts;
